<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header
        title="payroll.menuItemLabels.benefitsAndDeductions"
        [menuService]="payrollModuleMenuService"
        [back]="true"
    />
    @if (benefitCode) {
        <app-segment-header
            title="payroll.dental-benefits.assign.title"
            [titleParams]="{ code: benefitCode }"
            subtitle="payroll.dental-benefits.table.codeDescriptions.{{ benefitCode }}"
        >
            <ui-button class="buttons" type="primary" (click)="bulkAttachDetachEmployees()">{{
                'payroll.dental-benefits.assign.addRemoveEmployees' | translate
            }}</ui-button>
        </app-segment-header>
        <ui-card class="scrollable-table-container" [withSpacing]="false">
            @if (dentalBenefitsAssignedTable) {
                <app-table
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                    [table]="dentalBenefitsAssignedTable"
                    (menuItemSelected)="handleMenuItemSelected($event)"
                >
                    <app-empty-state class="empty-state" />
                </app-table>
            }
        </ui-card>
    }
</div>

<!-- Dialogs -->
<ui-confirmation-dialog
    #detachEmployeeConfirmation
    header="{{
        'payroll.dental-benefits.assign.single-removal-confirmation.header'
            | translate: { employee: employeeToDetach() }
    }}"
    primaryButtonLabel="remove"
    secondaryButtonLabel="cancel"
    primaryButtonType="danger"
>
    <div>
        {{
            'payroll.dental-benefits.assign.single-removal-confirmation.disclaimer'
                | translate: { employee: employeeToDetach(), benefitCode }
        }}
    </div>
</ui-confirmation-dialog>

<app-common-bulk-select-payroll-employee-dialog
    [isConfirmationRequired]="true"
    [shouldResolveWithAdditionsAndRemovals]="true"
>
    <app-bulk-select-confirmation
        header="payroll.dental-benefits.assign.bulk-select-confirmation.header"
        additionsText="payroll.dental-benefits.assign.bulk-select-confirmation.additions"
        removalsText="payroll.dental-benefits.assign.bulk-select-confirmation.removals"
        [translationParams]="{ code: benefitCode }"
    >
    </app-bulk-select-confirmation>
</app-common-bulk-select-payroll-employee-dialog>
